import MainComponent from "views/consent/privacy-policy";

export default function ConsentPrivacyPolicyPage(props) {
    return (
        <>
            <MainComponent />
        </>
    );
}